var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto"},[_c('div',{staticClass:"inline-block min-w-full shadow rounded-lg overflow-hidden"},[_c('table',{staticClass:"min-w-full leading-normal"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }